import { SEPARATOR, exactValidator, genericValidateName, uuidValidator } from './genericName';
import { libFund } from './index';
export var prefix = 'variants';
export var prefixWithSeparator = prefix + SEPARATOR;
export var IDToName = function (_a) {
    var fundID = _a.fundID, variantID = _a.variantID;
    return libFund.IDToName({ fundID: fundID }) + '/' + prefixWithSeparator + variantID;
};
export var validateName = genericValidateName([
    exactValidator(libFund.prefix),
    uuidValidator(),
    exactValidator(prefix),
    uuidValidator(),
]);
export var nameToID = function (name) {
    validateName(name); // throws if invalid
    var parts = name.split(SEPARATOR);
    return {
        fundID: parts[1],
        variantID: parts[3],
    };
};
